/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["Ꭲ", "ᏌᎾᎴ", "ᏒᎯᏱᎢᏗᏢ"], ["ᎢᎦ", "ᏌᎾᎴ", "ᏒᎯᏱᎢᏗᏢ"], u], [["ᎢᎦ", "ᏌᎾᎴ", "ᏒᎯᏱᎢᏗᏢ"], u, u], ["12:00", ["00:00", "12:00"], ["12:00", "24:00"]]];
